import { useQuery } from '@tanstack/react-query';

import getHelpRequestStatus from 'Api/host-help-partner/getHelpRequestStatus';
import getHelpRequestStatusResponse from './model/response/getHelpRequestStatusResponse';
import { useUserInfo } from 'Store/userInfo';

const useGetHelpRequestStatus = ({ isPublic }) => {
  const { organization } = useUserInfo();
  const isMalayOrg = organization?.region === 'MY';

  return useQuery({
    queryKey: ['help-request-status'],
    queryFn: async () => {
      const response = await getHelpRequestStatus();

      const result = getHelpRequestStatusResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !isPublic && !isMalayOrg,
    gcTime: 0,
  });
};

export default useGetHelpRequestStatus;
